import { VisitMedicalImaging } from '@dreryk/egabinet-visit-frontend-api';

import { AddCircleIcon, IconSize, IconWrapper, Table } from '@dreryk/react-components';

import { VisitFormController } from '../../visitForm.types';

import { AddMedicalImagingLink } from './AddMedicalImagingLink';
import { useMedicalImagingDataConfiguration, useMedicalImagingTableColumns } from './MedicalImagingTable.hooks';
import { StyledMedicalImagingTable } from './MedicalImagingTable.styled';
import { MedicalImagingTableEmptyStatePlaceholder } from './MedicalImagingTableEmptyStatePlaceholder';

type MedicalImagingTableProps = {
   readonly visitId: number;
   readonly patientId: number;
   readonly controller: VisitFormController;
};

export const MedicalImagingTable = (props: MedicalImagingTableProps): JSX.Element => {
   const columns = useMedicalImagingTableColumns();
   const dataConfiguration = useMedicalImagingDataConfiguration(props.visitId);

   return (
      <StyledMedicalImagingTable direction={'column'}>
         <Table<VisitMedicalImaging>
            columns={columns}
            dataConfiguration={dataConfiguration}
            testId={'medicalImagingTable'}
            keyExtractor={'medicalInformationId'}
            placeholder={
               <MedicalImagingTableEmptyStatePlaceholder
                  patientId={props.patientId}
                  visitId={props.visitId}
                  controller={props.controller}
               />
            }
            compact
            bottomElement={
               <AddMedicalImagingLink
                  patientId={props.patientId}
                  visitId={props.visitId}
                  controller={props.controller}
                  icon={
                     <IconWrapper testId={'addMedicalImagingLinkIcon'} size={IconSize.SMALL}>
                        <AddCircleIcon />
                     </IconWrapper>
                  }
               />
            }
         />
      </StyledMedicalImagingTable>
   );
};
